import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'

function getUser() {
  return Auth.currentAuthenticatedUser().then((user) => {
    if (user && user.signInUserSession) {
      return user
    } else {
      return null
    }
  }).catch(err => {
    console.log(err);
    return null;
  });
}

async function getToken() {
  return await Auth.currentSession().then((session) => {
    if (session) {
      return session.idToken.jwtToken
    } else {
      return null
    }
  }).catch(err => {
    console.log(err);
    return null;
  });
}

function getGroups () {
  return Auth.currentAuthenticatedUser().then((user) => {
    if (user && user.signInUserSession) {
      return user.signInUserSession.accessToken.payload['cognito:groups']
    } else {
      return null
    }
  }).catch(err => {
    console.log(err)
    return null
  })
}

function getUserName () {
  return Auth.currentAuthenticatedUser().then((user) => {
    if (user && user.signInUserSession) {
      return user
    } else {
      return null
    }
  }).catch(err => {
    console.log(err)
    return null
  })
}

function signUp(username, password) {
  return Auth.signUp({
    username,
    password,
    attributes: {
      email: username,
    },
  })
    .then(data => {
      AmplifyEventBus.$emit('localUser', data.user);
      if (data.userConfirmed === false) {
        AmplifyEventBus.$emit('authState', 'confirmSignUp');
      } else {
        AmplifyEventBus.$emit('authState', 'signIn');
      }
      return data;
    })
    .catch(err => {
      alert('Имэйл эсвэл Нууц үг ээ шалгана уу !!!')
      console.log(err);
    });
}

function confirmSignUp(username, code) {
  return Auth.confirmSignUp(username, code).then(data => {
    AmplifyEventBus.$emit('authState', 'signIn')
    return data // 'SUCCESS'
  })
    .catch(err => {
      console.log(err);
      throw err;
    });
}

function resendSignUp(username) {
  return Auth.resendSignUp(username).then(() => {
    return 'SUCCESS';
  }).catch(err => {
    console.log(err);
    return err;
  });
}

async function signIn(username, password) {
  try {
    const user = await Auth.signIn(username, password);
    if (user) {
      AmplifyEventBus.$emit('authState', 'signedIn');
    }
  } catch (err) {
    if (err.code === 'UserNotConfirmedException') {
      alert('Админд хандаж бүртгэлээ баталгаажуулна уу !!!')
    } else if (err.code === 'PasswordResetRequiredException') {
      // The error happens when the password is reset in the Cognito console
      // In this case you need to call forgotPassword to reset the password
      // Please check the Forgot Password part.
    } else if (err.code === 'NotAuthorizedException') {
      alert('Имэйл эсвэл Нууц үг ээ шалгана уу !!!')
    } else if (err.code === 'UserNotFoundException') {
      alert('Хэрэглэгч бүртгэлгүй байна !!!')
    } else {
      console.log(err);
    }
  }
}

function signOut() {
  return Auth.signOut()
    .then(data => {
      AmplifyEventBus.$emit('authState', 'signedOut');
      return data;
    })
    .catch(err => {
      console.log(err);
      return err;
    });
}
async function checkCurrentUserExist() {
  return Auth.currentUserInfo()
    .then(async data => {
      if (!data || !Object.prototype.hasOwnProperty.call(data, "username")) {
        await Auth.signOut();
        AmplifyEventBus.$emit("authState", "signedOut");
      }
      return data;
    })
    .catch(async () => {
      await Auth.signOut();
      AmplifyEventBus.$emit("authState", "signedOut");
    });
}

export {getUser, signUp, confirmSignUp, resendSignUp, signIn, signOut, getToken, getUserName, getGroups, checkCurrentUserExist};
